import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-teal-700" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  // Force onboarding: students to survey, associations to their survey
  if (user.role === "student" && !user.survey_completed && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }
  if (user.role === "association" && !user.survey_completed && location.pathname !== "/onboarding/association") {
    return <Navigate to="/onboarding/association" replace />;
  }
  return children;
}
